var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "box has-sticky-tile" }, [
    _c("div", { staticClass: "columns" }, [
      _c(
        "div",
        {
          staticClass:
            "column is-narrow is-flex is-align-items-center is-justify-content-center",
        },
        [
          _c("p", { staticClass: "title" }, [
            _vm._v("Batch " + _vm._s(_vm.value.batchNo)),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "column is-narrow is-flex is-align-items-center is-justify-content-center",
        },
        [
          _c("div", { staticClass: "is-flex is-flex-direction-column" }, [
            _c("span", {}, [_vm._v("Batch Status")]),
            _c("div", { staticClass: "select is-fullwidth is-small" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.batchStatus,
                      expression: "value.batchStatus",
                    },
                  ],
                  attrs: { disabled: !_vm.isCanEdit },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.value,
                        "batchStatus",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(_vm.ormBatchStatusType, function (status, propertyName) {
                  return _c(
                    "option",
                    { key: status, domProps: { value: status } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$filters.formatOrmBatchStatus(propertyName)
                          ) +
                          " "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "column" }, [
        _c(
          "div",
          {
            staticClass:
              "is-flex is-flex-direction-row is-justify-content-space-between",
            staticStyle: { width: "100%" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Batch Total Jobs"),
                ]),
                _c(
                  "span",
                  { staticClass: "is-size-4 is-size-4 has-text-weight-bold" },
                  [_vm._v(_vm._s(_vm.quotes.length))]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Total Value Range"),
                ]),
                _c(
                  "span",
                  { staticClass: "is-size-4 is-size-4 has-text-weight-bold" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.value.perQuoteTotalMin ?? 0,
                          _vm.$userInfo.locale,
                          false,
                          0
                        )
                      ) +
                        " - " +
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.value.perQuoteTotalMax,
                            _vm.$userInfo.locale,
                            false,
                            0
                          )
                        )
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Actual ARC"),
                ]),
                _c(
                  "span",
                  { staticClass: "is-size-4 is-size-4 has-text-weight-bold" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.actualARC,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Target ARC"),
                ]),
                _c(
                  "span",
                  { staticClass: "is-size-4 is-size-4 has-text-weight-bold" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.value.agreedArc,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("ALR Threshold"),
                ]),
                _c(
                  "span",
                  { staticClass: "is-size-4 is-size-4 has-text-weight-bold" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.value.alrLowerThreshold,
                          _vm.$userInfo.locale
                        )
                      ) +
                        " - " +
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.value.alrUpperThreshold,
                            _vm.$userInfo.locale
                          )
                        )
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v(" Actual Labour Rate "),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "is-size-4 is-size-4 has-text-weight-bold",
                    class: {
                      "has-text-danger":
                        _vm.alr < _vm.alrLowerThreshold ||
                        _vm.alr > _vm.alrUpperThreshold,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.alr,
                            _vm.$userInfo.locale
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.alr < _vm.alrLowerThreshold ||
                              _vm.alr > _vm.alrUpperThreshold,
                            expression:
                              "alr < alrLowerThreshold || alr > alrUpperThreshold",
                          },
                        ],
                        staticClass:
                          "icon has-text-danger tooltip is-tooltip-danger",
                        attrs: {
                          "data-tooltip":
                            _vm.alr < _vm.alrLowerThreshold
                              ? "ALR is below threshold"
                              : "ALR is above threshold",
                        },
                      },
                      [_c("i", { staticClass: "mdi mdi-alert" })]
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-flex-direction-column is-align-items-center",
              },
              [
                _c("span", { staticClass: "header-text-divider" }, [
                  _vm._v("Estimated Adjusted Labour Rate"),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "is-size-4 is-size-4 has-text-weight-bold",
                    class: {
                      "has-text-danger":
                        _vm.adjustedAlr < _vm.alrLowerThreshold ||
                        _vm.adjustedAlr > _vm.alrUpperThreshold,
                      "has-text-success":
                        _vm.adjustedAlr >= _vm.alrLowerThreshold &&
                        _vm.adjustedAlr <= _vm.alrUpperThreshold,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.adjustedAlr,
                            _vm.$userInfo.locale
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.adjustedAlr < _vm.alrLowerThreshold ||
                              _vm.adjustedAlr > _vm.alrUpperThreshold,
                            expression:
                              "adjustedAlr < alrLowerThreshold || adjustedAlr > alrUpperThreshold",
                          },
                        ],
                        staticClass:
                          "icon has-text-danger tooltip is-tooltip-danger",
                        attrs: {
                          "data-tooltip":
                            _vm.adjustedAlr > _vm.alr
                              ? "Increase the labour rate"
                              : "Decrease the labour rate",
                        },
                      },
                      [_c("i", { staticClass: "mdi mdi-alert" })]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }